import { createAction, props } from '@ngrx/store';
import { Medication } from '../../models/medication';
import { MedicationPrescription } from '../../models/medication-prescription';
import { SelectedMedication } from '../../models/selected-medication';

export const getPatientMedications = createAction(
  '[Medications] Get Patient Medications',
  props<{ patientId: number }>()
);

export const getPatientMedicationsSuccess = createAction(
  '[Medications] Get Patient Medications Success',
  props<{ medications: Medication[] | null }>()
);

export const getPatientMedicationsFailure = createAction(
  '[Medications] Get Patient Medications Failure',
  props<{ error: unknown }>()
);

export const createRefillRequest = createAction('[Medications] Create Refill Request', props<{ pharmacyId: number }>());

export const createRefillRequestSuccess = createAction('[Medications] Create Refill Request Success');

export const createRefillRequestFailure = createAction(
  '[Medications] Create Refill Request Failure',
  props<{ error: unknown }>()
);

export const navigateToMedicationVerification = createAction('[Medications] Navigate to Medication Verification');

export const getPatientMedicationById = createAction('[Medications] Get Patient Medications By Id');

export const getPatientMedicationByIdSuccess = createAction(
  '[Medications] Get Patient Medications By Id Success',
  props<{ medications: Medication[] | null; selectedMeds: SelectedMedication[] | null }>()
);

export const getPatientMedicationByIdFailure = createAction(
  '[Medications] Get Patient Medications By Id Failure',
  props<{ error: unknown }>()
);

export const setSelectedMedications = createAction(
  '[Medications] Set Selected Medications',
  props<{ medications: SelectedMedication[] | null }>()
);

export const getSelectedMedications = createAction('[Medications] Get Selected Medications');

export const getSelectedMedicationsSuccess = createAction(
  '[Medications] Get Selected Medications Success',
  props<{ medications: SelectedMedication[] | null }>()
);

export const clearMedicationsState = createAction('[Medications] Clear Medications State');

export const clearMedicationsStateSuccess = createAction('[Medications] Clear Medications State Success');

export const getMedicationPrescriptions = createAction(
  '[Medications] Get Medication Prescriptions',
  props<{ medicationId: number; isHomeMedication: boolean }>()
);

export const getMedicationPrescriptionsSuccess = createAction(
  '[Medications] Get Medication Prescriptions Success',
  props<{ medicationId: number; isHomeMedication: boolean; prescriptions: MedicationPrescription[] | null }>()
);

export const getMedicationPrescriptionsFailure = createAction(
  '[Medications] Get Medication Prescriptions Failure',
  props<{ error: unknown }>()
);
